import { Component, OnInit, ViewChild, Input, ElementRef } from '@angular/core';
import { GoogleTagManagerService } from '../../shared/google-tag-manager.service';
import { BbdbTimerComponent } from '../../bdb-timer/bdb-timer.component';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { RedirectService } from '../../shared/redirect.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { OneTimePasswordService } from '../services/bdb-otp.service';
import { ServiceErrorEnum } from '../../enums/service-error.enum';
import { SendOtpHttpStatusEnum } from './send-otp-http-status.enum';
import { environment } from '../../../../environments/environment';
import { AuthenticationRnecComponent } from '../../authentication-rnec/authentication-rnec.component';
import { SessionStorageKeysEnum } from '../../models/session-storage-keys-enum';

type MessageType = 'SMS' | 'Whatsapp' | 'Call';

@Component({
  selector: 'app-bdb-validate-one-time-password',
  templateUrl: './bdb-validate-one-time-password.component.html',
  styleUrls: ['./bdb-validate-one-time-password.component.scss']
})
export class BdbValidateOneTimePasswordComponent implements OnInit {

  modalReference;
  isTimeOut = false;
  closeResult: string;
  cellphoneNumber: string;
  disabledButton: boolean = true;
  lengthNumber: boolean = false;
  censoredCellphoneNumber: String;

  // retry options
  smsOption: boolean;
  whatsappOption: boolean;
  callOption: boolean;
  retryToastMessages = [
    'Código enviado exitosamente',
    'Enviando código a tu celular...',
    'Nos contactaremos a tu celular para brindarte el código de 4 dígitos.'];

  totalTimeInSeconds: number;
  currentOtpForwardingAttempts: number;
  otpForwardingAttempts: number;
  currentTimeInSeconds: number;
  isValidInput: boolean = false;
  timeout: boolean = false;
  oneTimePassword: string = '';
  successfulValidation: boolean = false;

  @Input() title: string;
  @Input() colorTitle: string;
  @Input() subtitle: string;
  @Input() colorSubTitle: string;
  @Input() imgLogoClass: string;
  @Input() selectOne: string;
  @Input() selectTwo: string;
  @Input() tamHeight: string;
  @Input() fnSelectOne;

  @ViewChild('timer') timer: BbdbTimerComponent;
  @ViewChild('cmpModal') cmpModal: AuthenticationRnecComponent;
  @ViewChild('bdbValidateOtp') bdbValidateOtp: ElementRef;
  @ViewChild('bdbToast') bdbToast: ElementRef;
  @ViewChild('bdbRetryOTP') bdbRetryOTP: ElementRef;

  constructor(
    private oneTimePasswordService: OneTimePasswordService,
    private bdbSessionStrgService: BdbSessionStrgService,
    private googleTagManagerService: GoogleTagManagerService,
    private modalService: NgbModal,
    private redirectService: RedirectService,
    private router: Router
  ) { }

  ngOnInit() {
    this.cellphoneNumber = this.bdbSessionStrgService.get('cellphoneNumber');
    this.showFirstTimeModal();
    this.googleTagManagerService.sendInfo(window.location.pathname, 'Validate OneTimePassword');
    this.otpForwardingAttempts = parseInt(environment.otpForwardingAttempts, 10);
    this.currentOtpForwardingAttempts = 0;
    this.totalTimeInSeconds = parseInt(environment.otpValidationTime, 10);
    this.smsOption = environment.smsOption;
    this.whatsappOption = environment.whatsappOption;
    this.callOption = environment.callOption;
    this.censorCellphoneNumber();
    this.initializeTime();
  }

  private showFirstTimeModal() {
    const mustShowModal = this.bdbSessionStrgService.get('firstTimeModal');
    if (mustShowModal) {
      console.log('first time modal was already shown');
    } else {
      this.bdbToast.nativeElement.type = 'SUCCESS';
      this.bdbToast.nativeElement.message = this.retryToastMessages[0];
      this.bdbToast.nativeElement.show();
      // this.bdbToast.nativeElement.showSuccessToast('', this.retryToastMessages[0], 3000);
      this.bdbSessionStrgService.save('firstTimeModal', 'true');
    }
  }

  private censorCellphoneNumber(): void {
    const cellphoneNumber = this.bdbSessionStrgService.get('cellphoneNumber');
    this.censoredCellphoneNumber = '******';
    if (cellphoneNumber) {
      this.censoredCellphoneNumber += cellphoneNumber.substring(cellphoneNumber.length - 4);
    } else {
      console.error('no cellphone was found');
    }
  }

  open(content) {
    this.modalReference = this.modalService.open(content, { keyboard: false, backdrop: 'static' });
    this.modalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
    });
  }

  validateOTP() {
    let code = this.oneTimePassword;
    code = code.replace(/\D/g, '');
    if (this.isValidCode(code)) {
      const documentNumber = this.bdbSessionStrgService.get('identityNumber');
      const uuidAuth = this.bdbSessionStrgService.get('uuidAuth');
      const oneTimePasswordValidateRequest = {
        'numberIdentification': documentNumber,
        'codeOtp': code,
        'numberIdentificationType': this.bdbSessionStrgService.get('identityType'),
        'cellphone': this.bdbSessionStrgService.get('cellphoneNumber'),
        'keyPhone': this.bdbSessionStrgService.get('cellphoneNumber'),
        'sessionIdTm': null,
        'uuid': uuidAuth
      };
      this.showModalLoading();
      this.oneTimePasswordService.validateOneTimePasswordOffice(oneTimePasswordValidateRequest).subscribe(response => {
        const status = response.status;
        this.showModalFunction(false);
        if (status === 200 && response._body) {
          const accessTokenFromResponse = JSON.parse(response._body).accessToken;
          this.bdbSessionStrgService.save('accessToken', accessTokenFromResponse);
          const mediumType = this.bdbSessionStrgService.get('mediumType');
          const recognitionEnabled = this.bdbSessionStrgService.get('recognitionEnabled') === 'true';
          if (mediumType && mediumType === '3' && recognitionEnabled) {
            this.router.navigate(['recognition']);
          } else {
            this.redirectService.redirectFromAuthentication();
          }
        } else {
          if (status === 403) {
            this.showAndHideErrorWithAnimation('El código ingresado no es correcto, verifica los campos y vuelve a intentarlo (011)');
          } else {
            console.error('VALIDATE-ONE-TIME-PASSWORD status:', status);
            this.oneTimePasswordService.redirectToErrorScreen(ServiceErrorEnum.VALIDATE_OTP_SERVICE_ERROR);
          }
        }
      }, error => {
        console.log('ERROR: VALIDATE-ONE-TIME-PASSWORD', error);
        this.oneTimePasswordService.redirectToErrorScreen(ServiceErrorEnum.VALIDATE_OTP_SERVICE_ERROR);
      });
    } else {
      this.setModalInfoAndStyleAndShow('Revisa el código ingresado', 'Intenta nuevamente');
      console.log('otp is missing');
    }
  }

  sendOTP(messageType: MessageType) {
    this.showModalLoading();
    const documentNumber = this.bdbSessionStrgService.get('identityNumber');
    const uuidAuth = this.bdbSessionStrgService.get('uuidAuth');
    const specificProductInfoUuid = this.bdbSessionStrgService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID);
    const otpRequest = {
      'numberIdentification': documentNumber,
      'keyPhone': this.cellphoneNumber,
      'numberIdentificationType': this.bdbSessionStrgService.get('identityType'),
      'cellphone': this.cellphoneNumber,
      'uuid': uuidAuth,
      'mode': messageType,
      'resendOtp': true,
      'attemptsOtp': this.currentOtpForwardingAttempts,
      'specificProductInfoUuid': specificProductInfoUuid
    };
    this.oneTimePasswordService.sendOneTimePasswordOffice(otpRequest).subscribe(response => {
      this.showModalFunction(false);
      const status = response.status + '';
      const isStatusOk = status === SendOtpHttpStatusEnum.OTP_SENT_SUCESSFULLY ||
        status === SendOtpHttpStatusEnum.OTP_SENT_SUCESSFULLY_HOUSING_CLIENT;
      if (isStatusOk) {
        // resetear estado componente
        this.showToastMessage(this.retryToastMessages[0]);
        this.resetToInitialValidationState();
        this.router.navigate(['validate-one-time-password']);
      }
    }, error => {
      console.log('ERROR: SEND-ONE-TIME-PASSWORD', error);
      this.oneTimePasswordService.redirectToErrorScreen(ServiceErrorEnum.SEND_OTP_SERVICE_ERROR);
    });
  }

  private showAndHideErrorWithAnimation(errorMessage: string) {
    this.bdbToast.nativeElement.type = 'ERROR';
    this.bdbToast.nativeElement.titleToast = 'Error de validación';
    this.bdbToast.nativeElement.message = errorMessage;
    this.bdbToast.nativeElement.show();
    /*
    this.bdbToast.nativeElement.showErrorToast('Error de validación', errorMessage, 3000);
    setTimeout(() => {
      this.bdbToast.nativeElement.close();
    }, 8000);
    */
  }

  private initializeTime() {
    // this.bdbSessionStrgService.save('currentTimeInSeconds', '10'); // keep commented, this is only for tests
    const savedCurrentTimeInSeconds = this.bdbSessionStrgService.get('currentTimeInSeconds');
    if (savedCurrentTimeInSeconds) {
      this.currentTimeInSeconds = Number(savedCurrentTimeInSeconds);
    } else {
      this.bdbSessionStrgService.delete('currentOtpForwardingAttempts');
      this.currentTimeInSeconds = this.totalTimeInSeconds;
    }
    const savedCurrentOtpForwardingAttempts = this.bdbSessionStrgService.get('currentOtpForwardingAttempts');
    if (savedCurrentOtpForwardingAttempts) {
      this.currentOtpForwardingAttempts = Number(savedCurrentOtpForwardingAttempts);
    }
    if (this.currentTimeInSeconds <= 0) {
      this.currentTimeInSeconds = 0;
      this.allowOtherOptionsOnTimeout();
    }
  }

  private resetToInitialValidationState() {
    console.log('Reset state');
    this.hideOtherOptions();
    this.bdbValidateOtp.nativeElement.cleanInput();
    this.bdbSessionStrgService.save('currentTimeInSeconds', this.totalTimeInSeconds.toString());
    this.bdbValidateOtp.nativeElement.reset(this.totalTimeInSeconds);
  }

  private hideOtherOptions() {
    this.bdbRetryOTP.nativeElement.close();
  }
  showModalFunction(view) {
    if (view) {
      if (this.modalReference !== undefined) {
        this.modalReference.close();
      }
      this.open(this.cmpModal);
    } else {
      this.modalReference.close();
    }
  }

  setModalInfoAndStyleAndShow(title: string, subtitle: string) {
    this.colorTitle = '#f69b31';
    this.colorSubTitle = '#282828';
    this.title = title;
    this.subtitle = subtitle;
    this.imgLogoClass = 'icon-warning';
    this.tamHeight = '';
    this.selectOne = 'OK';
    this.showModalFunction(true);
  }

  setModalMaxAttempts(title: string, subtitle: string) {
    this.colorTitle = '#f69b31';
    this.colorSubTitle = 'red';
    this.title = title;
    this.subtitle = subtitle;
    this.imgLogoClass = 'icon-warning';
    this.tamHeight = '';
    this.selectOne = 'OK';
    this.showModalFunction(true);
  }

  private isValidCode(code: string): boolean {
    return code !== null && code !== undefined && code.length === 4;
  }

  showModalLoading() {
    this.title = 'Estamos validando tu información';
    this.colorTitle = '#002c76';
    this.imgLogoClass = 'icon-loading';
    this.tamHeight = 'no-button-show';
    this.showModalFunction(true);
  }

  optionQuit() {
    this.redirectService.quit();
  }

  resendOTP(event: any): void {
    this.bdbValidateOtp.nativeElement.cleanInput();
    this.isValidInput = false;
    const medium = event.detail.value;
    if (this.isMaxOtpAttempts()) {
      this.setModalMaxAttempts('Hola!', 'Excediste el número máximo de intentos');
    } else {
      let retryToastMessage = this.retryToastMessages[1];
      if (medium === 'call') {
        retryToastMessage = this.retryToastMessages[2];
      }
      this.showToastMessage(retryToastMessage);
      if (medium === 'sms') {
        this.sendOTP('SMS');
      } else if (medium === 'whatsapp') {
        this.sendOTP('Whatsapp');
      } else if (medium === 'call') {
        this.sendOTP('Call');
      } else {
        console.error('you are not using this method correctly');
      }
    }
  }

  private isMaxOtpAttempts(): boolean {
    const status: boolean = this.currentOtpForwardingAttempts >= this.otpForwardingAttempts;
    this.currentOtpForwardingAttempts++;
    this.bdbSessionStrgService.save('currentOtpForwardingAttempts', this.currentOtpForwardingAttempts.toString());
    return status;
  }

  private showToastMessage(message: string) {
    this.bdbToast.nativeElement.type = 'SUCCESS';
    this.bdbToast.nativeElement.message = message;
    this.bdbToast.nativeElement.show();
    // this.bdbToast.nativeElement.showSuccessToast('', message, 3000);
  }

  public valueOtpFinished(event) {
    const otpValue = event.detail.value;
    console.log('event finished', otpValue);
    this.isValidInput = true;
    this.oneTimePassword = otpValue;
  }

  public valueOtpChanged(event) {
    const otpValue = event.detail.value;
    console.log('event changed', otpValue);
    if (otpValue !== 4) {
      this.isValidInput = false;
    }
  }

  public valueClockChanged(event) {
    const timeLeft = event.detail.value;
    this.timeout = event.detail.timeout;
    console.log('timeLeft:', timeLeft, 'timeout:', this.timeout);
    this.bdbSessionStrgService.save('currentTimeInSeconds', timeLeft.toString());
    const maxInterval = (2 / 3) * this.totalTimeInSeconds;
    if (timeLeft > 0 && timeLeft <= maxInterval) {
      this.allowOtherOptions();
    }
    if (this.timeout) {
      this.allowOtherOptionsOnTimeout();
      this.isValidInput = false;
      this.bdbValidateOtp.nativeElement.disableInput();
      this.bdbValidateOtp.nativeElement.cleanInput();
    } else {
      this.bdbValidateOtp.nativeElement.enableInput();
    }
  }

  public disableNextButton(): boolean {
    return !(this.oneTimePassword !== '' && this.isValidInput && !this.timeout);
  }

  private allowOtherOptions(): void {
    this.bdbRetryOTP.nativeElement.show();
  }

  private allowOtherOptionsOnTimeout() {
    this.bdbRetryOTP.nativeElement.show();
  }
}



// WEBPACK FOOTER //
// ./src/app/bdb-one-time-password/validate-otp/bdb-validate-one-time-password.component.ts